import { render, staticRenderFns } from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=template&id=3472377f&scoped=true"
import script from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=style&index=0&id=3472377f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3472377f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3472377f')) {
      api.createRecord('3472377f', component.options)
    } else {
      api.reload('3472377f', component.options)
    }
    module.hot.accept("./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=template&id=3472377f&scoped=true", function () {
      api.rerender('3472377f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetPdpParallelGridLegacy.vue"
export default component.exports